// extracted by mini-css-extract-plugin
export default {"subHeading":"Styles_subHeading__TOeWr","colorPicker":"Styles_colorPicker__xnHMF","hexColor":"Styles_hexColor__-pS5i","colorCode":"Styles_colorCode__YWca+"};